import React, { useEffect, useState } from "react";
import { hasUnseenSolidarityNews } from "../lib/solidarityNews";

/**
 * Small pulsing red dot next to the "Strikes" nav link when there's unseen news.
 * Re-checks on mount, on route change, and on `solidarity-news-seen` events.
 */
const StrikeNewsBadge = ({ className = "" }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const check = () => setShow(hasUnseenSolidarityNews());
    check();
    const handler = () => check();
    window.addEventListener("storage", handler);
    window.addEventListener("focus", handler);
    return () => {
      window.removeEventListener("storage", handler);
      window.removeEventListener("focus", handler);
    };
  }, []);

  if (!show) return null;

  return (
    <span
      className={`relative inline-flex items-center gap-1 ${className}`}
      data-testid="strike-news-badge"
      aria-label="New strike news"
      title="New strike news — tap Strikes to see"
    >
      <span className="absolute -top-1 -right-2 flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-600"></span>
      </span>
    </span>
  );
};

export default StrikeNewsBadge;
export { StrikeNewsBadge };
